import React from 'react';
import Section from './Section';
import UploadStepPanel from '../../components/forms/upload/UploadStepPanel';
import { UploadRow } from '../../components/forms/upload/UploadFileRow';

/**
 * /design — Wizard Step 1 Upload panel states. Compare with
 * `design/RFQ Wizard v2.dc.html` (Step 1 content column). Static rows
 * only — no network; the connected step wires useUploadStep instead.
 */

const ROWS: UploadRow[] = [
  { name: 'AMR-Drive-BOM-v3.xlsx', size: 151552, status: 'extracted', componentsFound: 34 },
  { name: 'Hub-Motor-Datasheet.pdf', size: 2202010, status: 'uploaded' },
  { name: 'Chassis-Drawing-RevB.pdf', size: 5033165, status: 'uploading', progress: 64 },
  { name: 'Gearbox-Spec.docx', size: 391800, status: 'failed', error: 'Upload failed — file could not be processed' },
];

const noop = () => undefined;

/** Fixture rate/balance — the connected step reads both from the meter. */
const PRICING = { rate: 100, balance: 4935, pending: false };

const UploadStepGallery: React.FC = () => (
  <>
    <Section title="Wizard step 1 — upload panel (per-file states)">
      <div className="mx-auto max-w-content">
        <UploadStepPanel rows={ROWS} onRemove={noop} onBack={noop} onContinue={noop} />
      </div>
    </Section>
    <Section title="Wizard step 1 — credits line (rule · extracted · needs attention · free)">
      <div className="mx-auto flex max-w-content flex-col gap-s7">
        <UploadStepPanel
          rows={ROWS.slice(0, 2)}
          onRemove={noop}
          onBack={noop}
          onContinue={noop}
          pricing={PRICING}
        />
        <UploadStepPanel
          rows={ROWS.slice(0, 1)}
          onRemove={noop}
          onBack={noop}
          onContinue={noop}
          pricing={PRICING}
          extraction={{ components: 34, needsAttention: 0 }}
        />
        <UploadStepPanel
          rows={ROWS.slice(0, 1)}
          onRemove={noop}
          onBack={noop}
          onContinue={noop}
          pricing={PRICING}
          extraction={{ components: 34, needsAttention: 3 }}
        />
        <UploadStepPanel
          rows={ROWS.slice(0, 1)}
          onRemove={noop}
          onBack={noop}
          onContinue={noop}
          pricing={{ rate: 0, balance: 4935, pending: false }}
          extraction={{ components: 34, needsAttention: 0 }}
        />
      </div>
    </Section>
    <Section title="Wizard step 1 — empty · extracting · extraction error">
      <div className="mx-auto flex max-w-content flex-col gap-s7">
        <UploadStepPanel rows={[]} onBack={noop} onContinue={noop} />
        <UploadStepPanel
          rows={ROWS.slice(0, 2)}
          onRemove={noop}
          onBack={noop}
          onContinue={noop}
          isExtracting
          continueDisabled
        />
        <UploadStepPanel
          rows={ROWS.slice(0, 2)}
          onRemove={noop}
          onBack={noop}
          onContinue={noop}
          extractionError="Failed to extract documents — the BOM sheet has no readable rows."
        />
      </div>
    </Section>
  </>
);

export default UploadStepGallery;
